import React, { ReactElement, useEffect, useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

interface Props {
  yValue: string | null;
  failureCriterion: number;
  failureData: any;
  customFailures: any;
}

export default function CustomTable({
  yValue,
  failureCriterion,
  failureData,
  customFailures,
}: Props): ReactElement {
  const [height, setHeight] = useState(window.innerHeight - 55);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight - 55);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });

  return (
    <TableContainer
      style={{
        border: "solid 1px",
        borderRadius: "5px",
        marginRight: "10px",
        overflowY: "auto",
        height: height,
      }}
    >
      <Table aria-label="simple table" size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <b>DUT</b>
            </TableCell>
            <TableCell>
              <b>{`@${yValue} ${failureCriterion}%`}</b>
            </TableCell>
            <TableCell>
              <b>Custom Failures</b>
            </TableCell>
            <TableCell>
              <b>Machine Log Failures</b>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {failureData.map((e: any) => (
            <TableRow key={e.dut}>
              <TableCell>
                <i>{e.dut}</i>
              </TableCell>
              <TableCell>
                <b>{e.failureZyklus}</b>
              </TableCell>
              <TableCell>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {customFailures &&
                  customFailures[e.dut] &&
                  customFailures[e.dut].error ? (
                    <>
                      <>
                        <i>{customFailures[e.dut].error}</i>
                      </>
                      <>
                        <b>{customFailures[e.dut].zyklus}</b>
                      </>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <>
                    <i>{e.error} </i>
                  </>
                  <>
                    <b>{e.errorZyklus}</b>
                  </>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
